__turbopack_context__.v({
  "anchor": "Privacy-module__wyew6W__anchor",
  "borders": "Privacy-module__wyew6W__borders",
  "grayBackground": "Privacy-module__wyew6W__grayBackground",
  "legalBasisModal": "Privacy-module__wyew6W__legalBasisModal",
  "modalBody": "Privacy-module__wyew6W__modalBody",
  "pageWrapper": "Privacy-module__wyew6W__pageWrapper",
  "privacyCallout": "Privacy-module__wyew6W__privacyCallout",
  "privacyInlineTable": "Privacy-module__wyew6W__privacyInlineTable",
  "privacyTable": "Privacy-module__wyew6W__privacyTable",
  "privacyTr": "Privacy-module__wyew6W__privacyTr",
});
